import React, { useState } from 'react';
import { localize } from '@deriv-com/translations';
import './risk-disclaimer.css';

const STORAGE_KEY = 'smarttrader_risk_disclaimer_dont_show_again';

const shouldShowDisclaimer = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) !== 'false';
    } catch (error) {
        return true;
    }
};

const hideDisclaimer = () => {
    try {
        window.localStorage.setItem(STORAGE_KEY, 'false');
    } catch (error) {
        // Keep the close action working even when storage is unavailable.
    }
};

const RiskDisclaimer = () => {
    const [is_visible, setIsVisible] = useState(shouldShowDisclaimer);
    const [is_popup_visible, setPopupVisible] = useState(false);

    const togglePopup = () => {
        setPopupVisible(!is_popup_visible);
    };

    const setDontShowAgain = () => {
        hideDisclaimer();
        setPopupVisible(false);
        setIsVisible(false);
    };

    if (!is_visible) {
        return null;
    }

    return (
        <div>
            <button className='risk-disclaimer-icon' type='button' onClick={togglePopup}>
                <span className='risk-disclaimer-icon__symbol'>!</span>
                <b>{localize('Risk Disclaimer')}</b>
            </button>
            {is_popup_visible && (
                <div className='popup_disclaimer' onClick={togglePopup}>
                    <div className='popup-content' onClick={event => event.stopPropagation()}>
                        <button
                            className='close-button'
                            type='button'
                            aria-label={localize('Close')}
                            onClick={togglePopup}
                        >
                            &times;
                        </button>
                        <h2>{localize('Risk Disclaimer')}</h2>
                        <p>
                            {localize('Deriv offers complex derivatives, such as options and contracts for difference ("CFDs"). These products may not be suitable for all clients, and trading them puts you at risk. Please make sure that you understand the following risks before trading Deriv products:')}
                        </p>
                        <ul>
                            <li>{localize('You may lose some or all of the money you invest in the trade.')}</li>
                            <li>
                                {localize('If your trade involves currency conversion, exchange rates will affect your profit and loss.')}
                            </li>
                        </ul>
                        <p>{localize('You should never trade with borrowed money or with money that you cannot afford to lose.')}</p>
                        <div className='bottom_btn'>
                            <button className='dont_show_again' type='button' onClick={setDontShowAgain}>
                                {localize('Don\'t Show Again')}
                            </button>
                            <button className='close_btn' type='button' onClick={togglePopup}>
                                {localize('Close')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RiskDisclaimer;
